import React from 'react';
import Select from '../select';

import { DateItem } from '../../../../types/react-select-options';

import './planet-image.scss';

export default function PlanetImageSelector({
  setSelectedPopover,
  monthList,
  monthSelect,
  setMonthSelect,
  yearList,
  yearSelect,
  setYearSelect,
  updatePlanetLayer,
}: {
  setSelectedPopover: Function;
  monthList: Array<any>;
  monthSelect: DateItem | '' | undefined;
  setMonthSelect: any;
  yearList: Array<any>;
  yearSelect: DateItem | '' | undefined;
  setYearSelect: Function;
  updatePlanetLayer: Function;
}) {
  const handleSubmitClick = () => {
    updatePlanetLayer();
    setSelectedPopover(false);
  };
  return (
    <div className='planet-date-panel'>
      <p>Select a Year/Month</p>
      <div className='rendering-rule-container'>
        <Select
          isMulti={false}
          options={yearList}
          value={yearSelect}
          onChange={setYearSelect}
          isDisabled={false}
          isClearable={false}
          placeholder='Select Year'
        />
        <Select
          isMulti={false}
          options={monthList}
          value={monthSelect}
          onChange={setMonthSelect}
          isDisabled={false}
          isClearable={false}
          placeholder='Select Month'
        />
      </div>
      <div className='button-wrapper'>
        <button onClick={() => handleSubmitClick()}>{monthSelect && yearSelect ? 'Submit' : 'Close'}</button>
      </div>
    </div>
  );
}
